module.exports = __webpack_public_path__ + "static/media/Programmer.cec0fb91.gif";